import { Provider } from '@/store/providers';
import { Card } from '@/types/learning/card';

export const getProviderCourseCount = (cards: Card[], provider: Provider): number =>
  cards.filter((card) => card.provider?.toLowerCase() === provider).filter((card) => card.available).length;
